<template>
    <div>

      <ed-modal 
			  :title="'Certificado'"
        :modal="showFormEdit" 
        :loadingSave="loadingSave"
        :onSave="salvar"
        width="60%"
		  >
			<div slot="modal-content">
        <el-form label-position="top" label-width="100px" :model="formData" ref="ruleForm">
          <div class="row">

            <div class="col-md-12">
                <el-form-item label="Empresa"
                    prop="empresa"
                    :rules="[
                        { required: true, message: 'Campo Obrigatorio'},
                    ]"
                    :class="error['empresa'] ? 'is-error' : ''"
                >
                    <el-select
                        v-model="formData.empresa"
                        filterable
                        remote
                        clearable 
                        placeholder="Digite o nome da empresa"
                        :remote-method="getEmpresa"
                        :loading="loadingEmpresa"
                    >
                        <el-option
                            v-for="item in lstEmpresa"
                            :key="item.id"
                            :value="item.id"
                            :label="item.nome"
                        >
                            <div class="col-md-12" style="float: left">
                                <b>{{ item.nome }}</b>
                            </div>
                            <div class="col-md-12" style="float: left; color: #8492a6; font-size: 13px">
                                  {{item.cnpj}}
                            </div>
                        </el-option>

                    </el-select>

                    <div v-if="error['empresa']" class="el-form-item__error">{{error['empresa'][0]}}</div>

                </el-form-item>
            </div>
              
            <div class="col-md-12">

                <el-form-item label="Tipo de Certificado"
                    prop="tipo_certificado_id"
                    :rules="[
                        { required: true, message: 'Campo Obrigatorio'},
                    ]"
                    :class="error['tipo_certificado_id'] ? 'is-error' : ''"
                  >
                    <el-select
                          v-model="formData.tipo_certificado_id"
                          placeholder="Selecione"
                    >
                        <el-option
                            v-for="item in lstTipoCertificado"
                            :key="item.id"
                            :value="item.id"
                            :label="item.descricao"
                        >
                        </el-option>
                    </el-select>
                    <div v-if="error['tipo_certificado_id']" class="el-form-item__error">{{error['tipo_certificado_id'][0]}}</div>
                </el-form-item>
            </div>

            <div class="form-group col-md-12">

                <el-form-item label="Certificado"
                    prop="arquivo"
                    :rules="[
                        { required: false, message: 'Campo Obrigatorio'},
                    ]"
                    :class="error['arquivo']? 'is-error' : ''"
                  >

                    <Upload :onChangeFile="onChangeArquivo" :currentFile="arquivo" ordem="1"></Upload>

                    <div v-if="error['arquivo']" class="el-form-item__error">{{error['arquivo'][0]}}</div>

                </el-form-item>
            </div>

            <div class="form-group col-md-6">

                <el-form-item label="Senha do Certificado"
                    prop="senha"
                    :rules="[
                        { required: true, message: 'Campo Obrigatorio'},
                    ]"
                    :class="error['senha']? 'is-error' : ''"
                  >

                    <el-input v-model="formData.senha" type="password"></el-input>

                    <div v-if="error['senha']" class="el-form-item__error">{{error['senha'][0]}}</div>

                </el-form-item>
            </div>

            <div class="form-group col-md-6">

                <el-form-item label="Confirmar Senha do Certificado"
                    prop="confirmar_senha"
                    :rules="[
                        { required: true, message: 'Campo Obrigatorio'},
                    ]"
                    :class="error['confirmar_senha']? 'is-error' : ''"
                  >

                    <el-input v-model="formData.confirmar_senha" type="password"></el-input>

                    <div v-if="error['confirmar_senha']" class="el-form-item__error">{{error['confirmar_senha'][0]}}</div>

                </el-form-item>
            </div>

            <div class="col-md-4">
                  <el-form-item label="Vincular Automaticamente"
                    prop="vincular"
                    :rules="[
                    ]"
                    :class="error['vincular'] ? 'is-error' : ''"
                  >
                    <span slot="label">
                        Vincular Automaticamente
                        <el-tooltip 
                          class="item" 
                          effect="dark" 
                          content="Ao habilitar essa opção o sistema vai vincular esse certificado para todos seus clientes automaticamente." 
                          placement="top"
                        >
                          <a href="#">
                              <i class="fa fa-question" aria-hidden="true"></i>
                          </a>
                        </el-tooltip>
                    </span>

                    <el-switch
                          v-model="formData.vincular"
                          :active-value="1"
                          :inactive-value="0"
                      >
                      </el-switch>
                    <div v-if="error['vincular']" class="el-form-item__error">{{error['vincular'][0]}}</div>
                  </el-form-item>
            </div>

            <div class="col-md-4" v-if="formData.id>0 && formData.vincular == 0">
                  <el-form-item label="Deletar Vínculo"
                    prop="deletar_vinculo"
                    :rules="[
                    ]"
                    :class="error['deletar_vinculo'] ? 'is-error' : ''"
                  >
                    <span slot="label">
                        Deletar Vínculo Existente
                        <el-tooltip 
                          class="item" 
                          effect="dark" 
                          content="Ao habilitar essa opção o sistema vai deletar esse certificado da base de seus clientes." 
                          placement="top"
                        >
                          <a href="#">
                              <i class="fa fa-question" aria-hidden="true"></i>
                          </a>
                        </el-tooltip>
                    </span>

                    <el-switch
                          v-model="formData.deletar_vinculo"
                          :active-value="1"
                          :inactive-value="0"
                      >
                      </el-switch>
                    <div v-if="error['deletar_vinculo']" class="el-form-item__error">{{error['deletar_vinculo'][0]}}</div>
                  </el-form-item>
            </div>

            <div class="col-md-4" v-if="formData.id>0">
                  <el-form-item label="Inserir Vínculo Não Existente"
                    prop="inserir_vinculo"
                    :rules="[
                    ]"
                    :class="error['inserir_vinculo'] ? 'is-error' : ''"
                  >
                    <span slot="label">
                        Inserir Vínculo Não Existente
                        <el-tooltip 
                          class="item" 
                          effect="dark" 
                          content="Ao habilitar essa opção o sistema vai inserir esse certificado da base de seus clientes que já estão cadastrados no sistema." 
                          placement="top"
                        >
                          <a href="#">
                              <i class="fa fa-question" aria-hidden="true"></i>
                          </a>
                        </el-tooltip>
                    </span>

                    <el-switch
                          v-model="formData.inserir_vinculo"
                          :active-value="1"
                          :inactive-value="0"
                      >
                      </el-switch>
                    <div v-if="error['inserir_vinculo']" class="el-form-item__error">{{error['inserir_vinculo'][0]}}</div>
                  </el-form-item>
            </div>
          </div>
        </el-form>
			</div>
    </ed-modal>

    <Vincular :showForm="showFormVincular" :certificado="formData"></Vincular>

    <div class="esocial-toolbar">
      <div class="esocial-toolbar__actions">
        <button type="button" class="esocial-search__btn esocial-search__btn--primary" @click="onRegister">
          <i class="fa fa-plus-circle"></i> Inserir Certificado
        </button>
      </div>

      <div class="esocial-search">
        <div class="esocial-search__group">
          <div class="esocial-search__input">
            <i class="fa fa-search"></i>
            <input
              type="text"
              v-model="search"
              placeholder="Pesquisar por Empresa, Tipo de Certificado..."
              @keyup.enter="getEsocialCertificado(search)"
            />
          </div>
          <button type="button" class="esocial-search__btn esocial-search__btn--attached" @click="getEsocialCertificado(search)">
            <i class="fa fa-search"></i> Buscar
          </button>
        </div>
      </div>
    </div>

    <esocial-tabela
      :tableHead="tableHead"
      :tableData="tableData"
      :loadingTable="loadingTable"
      :pagination="pagination"
      :response="response"
      :search="search"
      :onSearch="getEsocialCertificado"
      :onDelete="onDelete"
      emptyText="Nenhum certificado encontrado para os filtros atuais."
    />

    </div>
</template>

<script>

    import EsocialTabela from '../includes/tabela'
    import Rest from 'common/rest'
    import Fct from 'common/rest'
    import Upload from 'common/upload'
    import EdModal from 'common/modal'
    import Vincular from './vincular'

    export default {
        name:"esocial-certificado",
        mixins:[Rest,Fct],
        components:{EsocialTabela,EdModal,Upload,Vincular},
        data () {
          return {
            search:null,
            formData:{
              id:0,
              tipo_certificado_id:null,
              empresa:null,
              arquivo:null,
              representante: null,
              senha:null,
              confirmar_senha:null,
              validade:null,
              vincular:0,
              inserir_vinculo:1
            },
            loadingTable:false,
            loadingSave:false,
            showFormEdit:false,
            showFormVincular:false,
            loadingEmpresa:false,
            pagination:{},
            error:{},
            response:{},
            arquivo:null,
            tableHead:[
              {
                key: 'tipo',
						    sortable: true,
						    label: 'Tipo',
              },
              {
                key: 'nome',
						    sortable: true,
						    label: 'Nome',
              },
              {
                key: 'validade',
						    sortable: true,
						    label: 'Validade',
              },
              {
                key: 'vincular',
						    sortable: true,
						    label: 'Vincular Automaticamente',
              },
              {
                key: 'data_cadastro',
						    sortable: true,
						    label: 'Data Cadastro',
              }
            ],
            tableData:[],
            lstTipoCertificado:[],
            lstEmpresa:[]
          }
        },

        created(){
        },

        mounted() {
          this.getParametros();
          this.getEsocialCertificado();
        },

        methods:{

            onRegister: function(){
                this.formData = {
                  id:0,
                  tipo_certificado_id:null,
                  arquivo:null,
                  representante: null,
                  senha:null,
                  confirmar_senha:null,
                  validade:null,
                  vincular:0,
                  deletar_vinculo:0,
                  inserir_vinculo:0
                }
                this.arquivo = null;
                this.showFormEdit = !this.showFormEdit;
            },

            onEdit(data){
              
              this.formData = {
                id: data.id,
                tipo_certificado_id: data.tipo_certificado_id,
                empresa: data.empresa_id,
                arquivo_name: data.arquivo_name,
                arquivo_size: data.arquivo_size,
                arquivo:null,
                representante: data.representante,
                senha:null,
                confirmar_senha:null,
                validade:null,
                vincular:parseInt(data.vincular),
                deletar_vinculo:0,
                inserir_vinculo:0
              }

              this.arquivo = null;

              if(this.formData.arquivo_id){
                this.arquivo = {name:this.formData.arquivo_name, size: this.formData.arquivo_size};
              }

              this.lstEmpresa = [{
                id: data.empresa_id,
                cnpj: data.empresa_cnpj,
                nome: data.empresa_nome_fantasia
              }];

              this.showFormEdit = !this.showFormEdit;
            },

            onVincularCertificado(data){

              this.formData = data;
              this.showFormVincular = !this.showFormVincular;
            },

            onDelete(data){

                var self = this;

                this.$confirm('O sistema vai excluir '+data.length+' registro(s). Deseja prosseguir?', 'Atenção', {
                    confirmButtonText: 'OK',
                    cancelButtonText: 'Cancelar',
                    type: 'warning'

                }).then(() => {

                self.loadingTable = true;

                this.post('esocial/certificados/deletar',{ids:data}).then((result)=>{
                    result = result[0];

                    self.loadingTable = false;

                    if(result.status == 200){

                          this.$message({
                            message: 'Registo excluido com sucesso',
                            type: 'success'
                          });

                          this.formataLista(result);

                        }

                });

              });
            },

            onChangeArquivo(e){
                e.preventDefault();
                this.formData.arquivo = e.target.files[0];
                this.arquivo = {name:this.formData.arquivo.name,size:this.formData.arquivo.size};
            },

            getEmpresa(_search){

                this.loadingEmpresa = true;
                this.lstEmpresa = [];

                this.get('/empresa',{search:_search}).then((result)=>{

                    result = result[0];

                    this.loadingEmpresa = false;

                    if(result.status == 200){
                      this.lstEmpresa = result.data.data;   
                    }
                });

            },

            getParametros(){

              this.post('/tipo/parent',{codigo:[200]}).then((result)=>{

                result = result[0];
                var data = result.data;

                if(result.status == 200){
                    this.lstTipoCertificado = data[200];
                }
              });
            },

            getEsocialCertificado(_search,_page){

                this.loadingTable = true;
                this.lstTabelaConteudo = [];
                this.hideAdvancedFilter = !this.hideAdvancedFilter;
                this.response = {};

                this.get('esocial/certificados',{page:_page,search:_search}).then((result)=>{

                    result = result[0];

                    this.loadingTable = false;
                    this.response = result;

                    if(result.status == 200){
                      this.formataLista(result);
                    }
                });
            },

            formataLista(result){

              var tableData = [], arrData = result.data.data;

              for (var i = 0; i < arrData.length; i++) {

                var 
                  styleDefault = '',
                  styleCertificado = ' Vence em '+arrData[i].validade_diff+' dia(s)', 
                  titleRiscoDinamico = '',
                  tipo_certificado = arrData[i].tipo_certificado_nome,
                  representante = arrData[i].empresa_nome_fantasia,
                  validade = arrData[i].validade,
                  vincular = arrData[i].vincular,
                  created_at = arrData[i].created_at;



                if(arrData[i].parent_id){
                  tipo_certificado = arrData[i].parent_tipo_certificado_nome;
                  representante = arrData[i].empresa_nome_fantasia+'<br><b style="font-size:9pt">Usando certificado de '+arrData[i].parent_empresa_nome_fantasia+'</b>';
                  validade = arrData[i].parent_validade;
                  vincular = arrData[i].parent_vincular;
                  created_at = arrData[i].parent_created_at;
                }

                if(arrData[i].validade_diff && arrData[i].validade_diff>0 && arrData[i].validade_diff<10){
                  styleDefault = 'color:#dbb734';
                  titleRiscoDinamico = 'O certificado vence em '+arrData[i].validade_diff+' dia(s)';
                }
                else if(arrData[i].validade_diff && arrData[i].validade_diff == 0){
                  styleDefault = 'color:#dbb734';
                  titleRiscoDinamico = 'O certificado vence hoje';
                  styleCertificado = ' Vence hoje';
                }
                else if(arrData[i].validade_diff && arrData[i].validade_diff<0){
                  styleDefault = 'color:red';
                  titleRiscoDinamico = 'O certificado venceu há '+Math.abs(arrData[i].validade_diff)+' dia(s)';
                  styleCertificado = ' Venceu há '+Math.abs(arrData[i].validade_diff)+' dia(s)';
                }
                else if(arrData[i].parent_id){
                  styleDefault = 'color:#3287bc';
                  titleRiscoDinamico = 'Esse certificado foi compartilhado por '+arrData[i].parent_empresa_nome_fantasia;
                  styleCertificado = '';
                }
                else{
                  styleCertificado = '';
                }

                var spanOpen = '<span style="' + styleDefault + '"' + (titleRiscoDinamico ? ' title="' + titleRiscoDinamico + '"' : '') + '>';

                var item = {
                  'tipo': spanOpen + tipo_certificado + '</span>',
                  'nome': spanOpen + arrData[i].id+' - '+representante + '</span>',
                  'validade': spanOpen + this.toDate(validade,true) + (styleCertificado ? '<br><small style="font-size:10px">' + styleCertificado.trim() + '</small>' : '') + '</span>',
                  'vincular':(vincular == '1' ? 'Sim' : 'Não'),
                  'data_cadastro':this.toDate(created_at,false),
                  _data:arrData[i],
                  buttons:[],
                };

                item.buttons.push({
                  icon: 'fa fa-pencil-square-o',
                  style: 'width:36px;height:36px;font-size:18px;color:#09f',
                  title: 'Editar Registro',
                  click: this.onEdit,
                });

                if(this.cliente.logged.cnpj == arrData[i].empresa_cnpj){
                  item.buttons.push(
                    {
                      icon: 'fa fa-users',
                      style: 'width:36px;height:36px;font-size:18px;color:#34c142',
                      title:'Vincular clientes',
                      click: this.onVincularCertificado
                    }
                  );

                }

                item.buttons.push({
                  icon: 'fa fa-trash',
                  style: 'width:36px;height:36px;font-size:18px;color:#c0392b',
                  title: 'Deletar Registro',
                  click: (rowData) => this.onDelete([rowData.id]),
                });

                tableData.push(item);
              }

              this.tableData = tableData;
              this.pagination = result.data;
            },

            salvar: function(formName){
              
              this.loadingSave = true;
              this.error = {};
              this.response = {};

              var data = new FormData();

              data.append('id', this.formData.id);
              data.append('tipo_certificado_id', this.formData.tipo_certificado_id);
              data.append('empresa', this.formData.empresa);
              data.append('representante', this.formData.representante);
              data.append('senha', this.formData.senha);
              data.append('confirmar_senha', this.formData.confirmar_senha);
              data.append('vincular', this.formData.vincular);
              data.append('deletar_vinculo', this.formData.deletar_vinculo);
              data.append('inserir_vinculo', this.formData.inserir_vinculo);

              if(this.formData.arquivo){
                data.append('arquivo', this.formData.arquivo);
              }

              this.post('esocial/certificados/salvar',data,false).then((result)=>{

                result = result[0];

                this.loadingSave = false;

                if(result.status == 200){

                  this.edMsg('Dados atualizados com sucesso');

                  this.showFormEdit = !this.showFormEdit;
                  this.formataLista(result);
                }
              });
            }

        }
    }
</script>

<style lang="scss" scoped>
.esocial-toolbar {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 15px;
  flex-wrap: nowrap;
}

.esocial-toolbar__actions {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-shrink: 0;
}

.esocial-search {
  display: flex;
  align-items: stretch;
  gap: 8px;
  flex: 1 1 320px;
  min-width: 0;
  justify-content: flex-end;
}

.esocial-search__group {
  display: flex;
  align-items: stretch;
  height: 36px;
  box-sizing: border-box;
  background: #fff;
  border: 1px solid #d0d4d9;
  border-radius: 8px;
  overflow: hidden;
  flex: 1 1 auto;
  min-width: 160px;
  transition: border-color 0.15s;

  &:focus-within {
    border-color: #09f;
  }
}

.esocial-search__input {
  display: flex;
  align-items: center;
  gap: 8px;
  background: transparent;
  padding: 0 12px;
  flex: 1 1 auto;
  min-width: 0;

  i {
    color: #9aa0a8;
    font-size: 12px;
  }

  input {
    border: none;
    background: transparent;
    outline: none;
    font-size: 12px;
    color: #1f2329;
    width: 100%;
    height: 100%;

    &::placeholder {
      color: #9aa0a8;
    }
  }
}

.esocial-search__btn {
  display: flex;
  align-items: center;
  gap: 6px;
  height: 36px;
  box-sizing: border-box;
  padding: 0 14px;
  border: 1px solid #e4e7ed;
  background: #fff;
  border-radius: 8px;
  font-size: 12px;
  font-weight: 500;
  color: #374151;
  cursor: pointer;
  white-space: nowrap;
  flex-shrink: 0;
  transition: background-color 0.15s, border-color 0.15s;

  &:hover {
    background: #f7f8f9;
  }

  &--attached {
    height: 100%;
    border: none;
    border-left: 1px solid #d0d4d9;
    border-radius: 0;
    background: #f7f8f9;

    &:hover {
      background: #eef0f2;
    }
  }

  &--primary {
    color: #fff;
    border-color: rgb(168, 121, 31);
    background: rgb(168, 121, 31);

    &:hover {
      background: rgb(148, 106, 27);
    }
  }
}
</style>



// WEBPACK FOOTER //
// index.vue?e6fca17c